<template>
  <div class="card">
    <div class="main-card-body">
      <div class="main-body__css">
        <div class="synthetic-salary card card-md-12">
            <el-card>
              <div slot="header">
                <p class="card-header__title">
                  Tổng hợp lương {{new Date().getFullYear()}}
                </p>
                <p class="card-header__sub">Tất cả đơn vị ( 1/2022 - {{new Date().getMonth() + 1}}/{{new Date().getFullYear()}} )</p>
              </div>
              <div class="card-body-md-12 card-body--flex">
                <div class="total-salary">
                  <div class="total-salary__item">
                    <div class="title--text">Tổng lương</div>
                    <div class="total-salary__item__value">
                      <b class="value">{{totalSalaryYear}}</b>
                      <span class="unit"> Tỷ đồng</span>
                    </div>
                  </div>
                </div>
                <div class="personal-income-tax">
                  <div>
                    <div class="title--text">Thuế thu nhập cá nhân</div>
                    <div class="personal-income-tax__value">
                      <b class="value">{{personalIncomeTax}}</b>
                      <span class="unit"> Tỷ đồng</span>
                    </div>
                  </div>
                </div>
                <div class="insurance">
                  <div>
                    <div class="title--text">Bảo hiểm</div>
                    <div class="insurance__value">
                      <b class="value">{{insurance}}</b>
                      <span class="unit"> Tỷ đồng</span>
                    </div>
                  </div>
                </div>
              </div>
            </el-card>
        </div>
        <div class="personnel-salary-control card card-md-12">
          <el-card>
            <div slot="header">
              <p class="card-header__title">Bảng điều khiển tiền lương nhân sự</p>
            </div>
            <div class="card-body-md-12">
              <b-row>
                <b-col lg="3" md="6">
                  <div class="card-body__block total-number-departments" @click="goToPage('department')">
                    <p class="title mb-4">
                      Tổng số <br/>phòng ban
                    </p>
                    <p class="count">
                      {{formartNumber(totalNumberDepartments)}}
                    </p>
                    <div class="icon">
                      <i class="isax-bold-document-text"></i>
                    </div>
                  </div>
                </b-col>
                <b-col lg="3" md="6">
                  <div class="card-body__block total-number-employees" @click="goToPage('employee')">
                    <p class="title mb-4">
                      Tổng số <br/>nhân viên
                    </p>
                    <p class="count">
                      {{formartNumber(totalEmployee)}}
                    </p>
                    <div class="icon">
                      <i class="isax-bold-document-copy"></i>
                    </div>
                  </div>
                </b-col>
                <b-col lg="3" md="6">
                  <div class="card-body__block total-salary" @click="goToPage('salary')">
                    <p class="title mb-4">
                      Tổng <br/>lương
                    </p>
                    <p class="count">
                      {{formartNumber(totalSalary)}}
                    </p>
                    <div class="icon">
                      <i class="isax-bold-edit-2"></i>
                    </div>
                  </div>
                </b-col>
                <b-col lg="3" md="6">
                  <div class="card-body__block net-payment">
                    <p class="title mb-4">
                      Thanh toán <br/>ròng
                    </p>
                    <p class="count">
                      {{formartNumber(netPayment)}}
                    </p>
                    <div class="icon">
                      <i class="isax-bold-note-favorite"></i>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </el-card>
        </div>
        <el-row :gutter="15" class="mb-3">
          <el-col :sm="24" :md="12">
            <div class="salary-fund card chart-card">
              <el-card>
                <div slot="header">
                  <p class="card-header__title">Qũy lương theo phòng ban</p>
                </div>
                <div class="card-body-md-12">
                  <EChart
                    :heightChart="'400'"
                    :optionChart="optionChartSalaryFund"
                  />
                </div>
              </el-card>
            </div>
          </el-col>
          <el-col :sm="24" :md="12">
            <div class="income-structure card chart-card">
              <el-card>
                <div slot="header">
                  <p class="card-header__title">Cơ cấu thu nhập</p>
                </div>
                <div class="card-body-md-12">
                  <EChart
                    :heightChart="'400'"
                    :optionChart="optionChartIncomeStructure"
                  />
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="15" class="mb-3">
          <el-col :sm="24" :md="14">
            <div class="wage card chart-card">
              <el-card>
                <div slot="header">
                  <p class="card-header__title">Mức lương gộp dựa trên vị trí</p>
                </div>
                <div class="card-body-md-12">
                  <EChart
                    :heightChart="'400'"
                    :optionChart="optionChartWage"
                  />
                </div>
              </el-card>
            </div>
          </el-col>
          <el-col :sm="24" :md="10">
            <div class="gender card chart-card">
              <el-card>
                <div slot="header">
                  <p class="card-header__title">Nhân viên / Giới tính</p>
                </div>
                <div class="card-body-md-12">
                  <EChart
                    :heightChart="'400'"
                    :optionChart="optionChartGender"
                  />
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import EChart from '../../../../component/EChart/EChart';
export default {
  props: {
    listDepartment: {
      type: Array,
      default: () => [],
    },
    listEmployee: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    EChart,
  },
  data() {
    return {
      totalSalaryYear: 3.07,
      personalIncomeTax: 514.51,
      insurance: 5.19,
      totalNumberDepartments: 0,
      totalEmployee: 0,
      totalSalary: 800000000,
      netPayment: 700000000,
      optionChartSalaryFund: {},
      optionChartIncomeStructure: {},
      optionChartWage: {},
      optionChartGender: {}
    }
  },
  methods: {
    goToPage(type) {
      if (type == 'department') {
        this.$router.push({ name: 'Admin-Department-list' });
      } else if (type == 'employee') {
        this.$router.push({ name: 'Admin-EmployeeManager-list' });
      } else if (type == 'salary') {
        this.$router.push({ name: 'Admin-Salary-SalaryPeriod-SalaryPeriodList' });
      }
    },
    routerPush(name, query) {
      if (query) {
        this.$router.push({ name: name, query: query }).catch(err => {
          if (err.name != "NavigationDuplicated") {
            throw err;
          }
        });
      } else {
        this.$router.push({ name: name }).catch(err => {
          if (err.name != "NavigationDuplicated") {
            throw err;
          }
        });
      }
    },
    countDataProp() {
    this.totalNumberDepartments = this.listDepartment.length;
      this.totalEmployee = this.listEmployee.filter(item => {
        return item.status === 'DANG_LAM_VIEC' || item.status === 'NGHI_SINH'
      }).length;
    },
    formartNumber(value) {
      if (value < 10) {
        return "0" + value
      } else if ( value >= 1000) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      } else {
        return value
      }
    },
    getSalaryFoud() {
      this.optionChartSalaryFund = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          },
          textStyle: {
            fontSize: 16,
            fontFamily: 'UTM Avo',
            fontWeight: 400,
          }
        },
        legend: {
          left: 'center',
          icon: 'circle',
          itemGap: 20,
          itemWidth: 20,
          textStyle: {
            fontSize: 16,
            fontFamily: 'UTM Avo',
            fontWeight: 400,
          }
        },
        grid: {
          left: '1%',
          right: '4%',
          bottom: '0%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            fontSize: 16,
            fontFamily: 'UTM Avo',
          }
        },
        yAxis: {
          type: 'category',
          data: ['Pháp chế',  'Kỹ thuật',  'Kế toán', 'Kinh doanh', 'IT', 'Marketing'],
          axisLabel: {
            fontSize: 16,
            fontFamily: 'UTM Avo',
            fontWeight: 'bold',
          }
        },
        series: [
          {
            name: 'Lương',
            type: 'bar',
            stack: 'total',
            color: '#826AF9',
            data: [75, 125, 60, 250, 275, 175]
          },
          {
            name: '% Hoa hồng',
            type: 'bar',
            stack: 'total',
            color: '#2D9AFF',
            data: [15, 15, 15, 15, 15, 15]
          },
          {
            name: 'Tăng ca',
            type: 'bar',
            stack: 'total',
            color: '#2CD9C5',
            data: [20, 20, 20, 20, 20, 20]
          },
        ]
      }
    },
    getIncomeStructure() {
      this.optionChartIncomeStructure = {
        tooltip: {
          trigger: 'item',
          formatter: `
            Cơ cấu thu nhập <br/>
            {b} : {d}%
          `,
          textStyle: {
            fontSize: 16,
            fontFamily: 'UTM Avo',
            fontWeight: 400,
          }
        },
        legend: {
          icon: 'circle',
          left: 'center',
          itemGap: 15,
          textStyle: {
            fontSize: 16,
            fontFamily: 'UTM Avo',
            fontWeight: 400,
          }
        },
        series: [
          {
            type: 'pie',
            top: '10%',
            radius: ['45%', '80%'],
            color: ['#9738FF', '#FFA115', '#24DBFF', "#FD1F9B", "#30F363"],
            label: {
              textStyle: {
                fontSize: 16,
                fontFamily: 'UTM Avo',
                fontWeight: 'bold',
              },
              formatter: `{c}%`
            },
            data: [
              { value: 6.82, name: 'Lương doanh số' },
              { value: 1.54, name: 'Quà lễ tết' },
              { value: 1.01, name: 'Phụ cấp trách nhiệm' },
              { value: 0.35, name: 'Thưởng NVSX' },
              { value: 90.52, name: 'Lương ngày công' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 5,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }
    },
    getWage() {
      this.optionChartWage = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          textStyle: {
            fontSize: 16,
            fontFamily: 'UTM Avo',
            fontWeight: 400,
          }
        },
        grid: {
          left: '2%',
          right: '4%',
          bottom: '2%',
          top: '1%',
          containLabel: true
        },
        yAxis:{
          type: 'category',
          data: ['Quản lý kỹ thuật', 'Quản lý kinh doanh', 'Giám đốc nhân sự', 'Giám đốc sản xuất', 'Giám đốc điều hành'],
          axisLabel: {
            fontSize: 16,
            fontFamily: 'UTM Avo',
            fontWeight: 'bold',
          }
        }
        ,
        xAxis:{
          type: 'value',
          axisLabel: {
            fontSize: 16,
            fontFamily: 'UTM Avo',
          }
        },
        series: [
          {
            name: 'Thu nhập',
            type: 'bar',
            barWidth: '60%',
            data: [20, 35, 55, 55, 80]
          }
        ]
      }
    },
    getGender() {
      this.optionChartGender = {
        tooltip: {
          trigger: 'item',
          textStyle: {
            fontSize: 16,
            fontFamily: 'UTM Avo',
            fontWeight: 400,
          }
        },
        series: [
          {
            name: 'Nhân viên / Giới tính',
            type: 'pie',
            // radius: '60%',
            color: ['#1F8FFF', '#30F363'],
            label: {
              textStyle: {
                fontSize: 16,
                fontFamily: 'UTM Avo',
                fontWeight: 'bold',
              }
            },
            data: [
              { value: 15, name: 'Nữ' },
              { value: 42, name: 'Nam' },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 5,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
  },
  created() {
    this.getSalaryFoud()
    this.getIncomeStructure()
    this.getWage()
    this.getGender()
    this.countDataProp()
  },
}
</script>
<style lang="scss" scoped>
.main-body__css{
  .card-md-12 {
    margin-bottom: 14px;
  }
}
::v-deep .el-card {
  .el-card__header{
    padding: 15px 15px 10px 15px;
    .card-header__css {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-select  {
        max-width: 150px;
        .el-input__inner {
          height: 33px !important;
        }
      }
    }
    .card-header__title{
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 700;
      font-size: 15px;
      line-height: 18px;
      color: #000000;
      margin-bottom: 6px;
    }
    .card-header__sub {
      color: #ABABAB;
      font-style: italic;
      font-weight: 300;
      font-size: 14px;
      line-height: 16px;
    }
  }
  .el-card__body{
    padding: 0 10px 15px 10px;
    .card-body-md-12 {
      &.card-body--flex {
        display: flex;
        justify-content: space-around;
        padding-top: 15px;
      }

      .title--text {
        font-family: 'Roboto';
        text-transform: uppercase;
        font-weight: 600;
        font-size: 15px;
        line-height: 18px;
        color: #ABABAB;
        margin-bottom: 10px;
      }
      .value {
        font-family: 'Roboto';
        font-weight: bolder;
        font-size: 30.8571px;
        line-height: 36px;
      }
      .unit {
        font-family: 'Roboto';
        font-weight: 500;
        font-size: 15px;
        line-height: 18px;
        color: #ABABAB;
      }
      .total-salary__item__value {
        color: #0ABF02;
      }
      .personal-income-tax__value {
        color: #B2427D;
      }
      .insurance__value {
        color: #017EFA;
      }

      [class^="col-"], [class*=" col-"] {
        padding-right: 5px;
        padding-left: 5px;
      }
      .card-body__block{
        position: relative;
        height: 120px;
        border-radius: 10px;
        color: #FFFFFF;
        padding: 17px 23px;
        &:hover {
          cursor: pointer;
        }
        .count {
          font-family: 'Roboto';
          font-weight: 700;
          font-size: 24px;
          line-height: 28px;
          color: #FFFFFF;
        }
        .title {
          font-family: 'Roboto';
          font-weight: 500;
          font-size: 16px;
          line-height: 19px;
          color: #FFFFFF;
          width: 120px;
        }
        .icon {
          position: absolute;
          top: 35%;
          transform: translate(0, -50%);
          right: 25px;
          [class^="isax-bold-"] {
            &::before {
              font-size: 40px;
              line-height: 40px;
            }
          }
        }
        &.total-number-departments{
          background: #FF4F00;
        }
        &.total-number-employees{
          background: #894FBF;
        }
        &.total-salary{
          background: #56AA1C;
        }
        &.net-payment{
          background: #51BFE2;
        }
      }
    }
  }
}
</style>
